import { defineComponent as _defineComponent } from 'vue';
import CompanyLayout from '@/Layouts/Company.vue';
import ToggleButton from 'primevue/togglebutton';
import { ref } from 'vue';
import Calendar from '@/Components/Calendar.vue';
import LinkButton from '@/Components/LinkButton.vue';
import { useRoute } from '@/Plugins/ziggy';
import { usePageProps } from '@/Plugins/page-props';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CalendarView',
    props: {
        orchard: {
            type: Object,
            required: true,
        },
        phenologicalPhases: {
            type: Array,
            default: [],
        },
    },
    setup(__props, { expose }) {
        expose();
        const props = __props;
        const route = useRoute();
        const user = usePageProps();
        const company = user.company();
        const routePrefix = user.isAdmin() ? 'admin.companies.' : '';
        const events = ref([]);
        events.value.push(...[
            {
                title: 'Dati acqua',
                start: '2023-04-01T09:00:00',
                end: '2023-04-01T10:00:00',
                classNames: 'event-marker irrigation-water-data',
                allDay: true,
            },
            {
                title: 'Fertilizzazione',
                start: '2023-04-01T10:00:00',
                end: '2023-04-01T11:00:00',
                classNames: 'event-marker nutrition-data',
                allDay: true,
            },
            {
                title: 'Dati foglie',
                start: '2023-04-03T09:00:00',
                end: '2023-04-03T10:00:00',
                classNames: 'event-marker leaves-data',
                allDay: true,
            },
            {
                title: 'Sintomatologie',
                start: '2023-04-04T17:00:00',
                end: '2023-04-04T18:00:00',
                classNames: 'event-marker symptoms',
                allDay: true,
            },
            {
                title: 'Irrigazione',
                start: '2023-04-05T09:00:00',
                end: '2023-04-05T10:00:00',
                classNames: 'event-marker irrigation',
                allDay: true,
            },
            {
                title: 'Dati Suolo',
                start: '2023-04-06T09:00:00',
                end: '2023-04-06T10:00:00',
                classNames: 'event-marker soil-data',
                allDay: true,
            },
            {
                title: 'Dati Suolo',
                start: '2023-04-18T09:15:00',
                end: '2023-04-18T09:30:00',
                classNames: 'event-marker soil-data',
                allDay: true,
            },
            {
                title: 'Dati Suolo',
                start: '2023-04-18T09:30:00',
                end: '2023-04-18T09:45:00',
                classNames: 'event-marker soil-data',
                allDay: true,
            },
            {
                title: 'Dati Suolo',
                start: '2023-04-18T09:45:00',
                end: '2023-04-18T10:00:00',
                classNames: 'event-marker soil-data',
                allDay: true,
            },
        ]);
        const __returned__ = { route, user, props, company, routePrefix, events, CompanyLayout, Calendar, LinkButton };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
